import React from "react";
import Cabecera from "./components/Cabecera";
import Contenido from "./components/Contenido";


import "./styles/util.css";
//import "./styles/custom_bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";


function App() {
  return (
    <div>
      {/* Header Site*/}
      <Cabecera />
      {/* Content Body*/}
      <div className="contenedor">
            <Contenido className="" />
      </div>
      
      {/* Footer Site*/}
      <footer></footer>
    </div>
  );
}

export default App;
